import React, { Component } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import { Trans } from "react-i18next";
import Snackbar from "@material-ui/core/Snackbar";
import CloseIcon from "@material-ui/icons/Close";
import { withTranslation } from "react-i18next";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import { taxServiceClient } from "../../AxiosClient";
import { connect } from "react-redux";
import { setApplicationProperties } from "../../redux/actions/universalActions";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const styles = (theme) => ({
  profilePage: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    marginTop: theme.spacing(1),
  },
});

export class ProfilePage extends Component {
  constructor(props) {
    super(props);
    this.handleSalutationChange = this.handleSalutationChange.bind(this);
    this.state = {
      salutation: props.currentUser.salutation || "n/a",
      firstName: props.currentUser.firstName || "",
      surname: props.currentUser.surname || "",
      email: props.currentUser.email || "",
      userLogin: props.currentUser.userLogin || "",
      updatedSnack: false,
      password: "",
      confirmPassword: "",
      emailError: false,
      passwordError: false,
      confirmPasswordError: false,
      emailRegExError: false,
      passwordsDontMatch: false,
      passwordRegexError: false,
      passwordRegex: "",
      passwordRegexErrorMessage: "",
      requiresPasswordChange: false,
      regEx: "",
      usernameTouched: false,
      emailTouched: false,
      passwordTouched: false,
      firstnameTouched: false,
      lastnameTouched: false,
      confirmPasswordTouched: false,
      userType: props.currentUser.userType || "named",
    };
  }

  componentDidMount() {
    this.buildRegexForOrganisation();
    this.buildPasswordErrorMessageForOrganisation();
    this.setState({ preferedLanguage: this.props.languages });
  }

  render() {
    const { classes, t } = this.props;
    return (
      <div className={classes.profilePage}>
        <FormControl>
          <TextField
            required
            id="username"
            label={t("label_username")}
            error={this.state.usernameTouched && this.state.userLogin === ""}
            onBlur={() => this.setState({ usernameTouched: true })}
            helperText={
              this.state.userLogin === ""
                ? this.props.t("global_required")
                : null
            }
            disabled={!this.props.isCreate || this.props.disableAll}
            onChange={this.handleUsernameChange}
            value={this.state.userLogin}
            className={classes.formControl}
          />
          <FormControl>
            <InputLabel
              className={classes.formControl}
              id="userTypeSelectLabel"
            >
              <Trans i18nKey="user_type" />
            </InputLabel>
            <Select
              labelId="userTypeSelectLabel"
              disabled={this.props.disableAll}
              value={this.state.userType}
              id="user-type"
              onChange={this.handleUserTypeChange}
              className={classes.formControl}
            >
              <MenuItem value="named">{t("user_type_named_user")}</MenuItem>
              <MenuItem value="concurrent">
                {t("user_type_concurrent_user")}
              </MenuItem>
              <MenuItem value="limited">{t("role_limitedUser")}</MenuItem>
            </Select>
          </FormControl>
          <FormControl>
            <InputLabel
              className={classes.formControl}
              id="salutationSelectLabel"
            >
              <Trans i18nKey="personal_details_title_label" />
            </InputLabel>
            <Select
              labelId="salutationSelectLabel"
              id="salutationSelect"
              disabled={this.props.disableAll}
              value={this.state.salutation}
              onChange={this.handleSalutationChange}
              className={classes.formControl}
            >
              <MenuItem value="n/a">N/A</MenuItem>
              <MenuItem value="mr">Mr</MenuItem>
              <MenuItem value="mrs">Mrs</MenuItem>
              <MenuItem value="miss">Miss</MenuItem>
              <MenuItem value="ms">Ms</MenuItem>
              <MenuItem value="dr">Dr</MenuItem>
            </Select>
          </FormControl>
          <TextField
            disabled={this.props.disableAll}
            id="firstName"
            label={t("personal_details_first_name_label")}
            onChange={this.handleFirstNameChange}
            onBlur={() => this.setState({ firstnameTouched: true })}
            error={this.state.firstnameTouched && this.state.firstName === ""}
            helperText={
              this.state.firstnameTouched && this.state.firstName === ""
                ? this.props.t("global_required")
                : null
            }
            value={this.state.firstName}
            className={classes.formControl}
            required
          />
          <TextField
            disabled={this.props.disableAll}
            id="lastName"
            label={t("personal_details_last_name_label")}
            onBlur={() => this.setState({ lastnameTouched: true })}
            error={this.state.lastnameTouched && this.state.surname === ""}
            helperText={
              this.state.lastnameTouched && this.state.surname === ""
                ? this.props.t("global_required")
                : null
            }
            onChange={this.handleLastNameChange}
            required
            value={this.state.surname}
            className={classes.formControl}
          />
          <TextField
            required
            error={this.state.emailError || this.state.emailRegExError}
            onBlur={() => this.setState({ emailTouched: true })}
            disabled={this.props.disableAll}
            id="email"
            label={t("global_email")}
            onChange={this.handleEmailChange}
            value={this.state.email}
            className={classes.formControl}
          />
          {this.state.emailError && (
            <FormHelperText error id="component-error-text">
              <Trans i18nKey="global_required" />
            </FormHelperText>
          )}
          {this.state.emailRegExError && (
            <FormHelperText error id="component-error-text">
              <Trans i18nKey="email_must_match_format" />
            </FormHelperText>
          )}
          {this.props.isCreate && (
            <div>
              <TextField
                fullWidth
                required
                error={
                  this.state.passwordError || this.state.passwordRegexError
                }
                disabled={this.props.disableAll}
                type="password"
                id="password"
                label={this.props.t("label_password")}
                onChange={this.handlePasswordChange}
                onBlur={() => this.setState({ passwordTouched: true })}
                value={this.state.password}
                className={classes.formControl}
              />
              {this.state.passwordError && (
                <FormHelperText error id="component-error-text">
                  <Trans i18nKey="global_required" />
                </FormHelperText>
              )}
              {this.state.passwordRegexError && (
                <FormHelperText error id="component-error-text">
                  {this.state.passwordRegexErrorMessage}
                </FormHelperText>
              )}
              <TextField
                fullWidth
                required
                error={
                  this.state.confirmPasswordError ||
                  this.state.passwordsDontMatch
                }
                disabled={this.props.disableAll}
                id="password-confirm"
                type="password"
                label={this.props.t("user_admin_confirm_password")}
                onBlur={() => this.setState({ confirmPasswordTouched: true })}
                onChange={this.handleConfirmPasswordChange}
                value={this.state.confirmPassword}
                className={classes.formControl}
              />
              {this.state.confirmPasswordError && (
                <FormHelperText error id="component-error-text">
                  <Trans i18nKey="global_required" />
                </FormHelperText>
              )}
              {this.state.passwordsDontMatch && (
                <FormHelperText error id="component-error-text">
                  <Trans i18nKey="passwords_must_match" />
                </FormHelperText>
              )}
            </div>
          )}
          <FormControl className={classes.formControl}>
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.requiresPasswordChange}
                  onChange={(e) => {
                    this.setState({ requiresPasswordChange: e.target.checked });
                    this.props.stateUpdated({
                      ...this.state,
                      requiresPasswordChange: e.target.checked,
                    });
                  }}
                />
              }
              label="Force new password"
            />
          </FormControl>
        </FormControl>
        {!this.props.hideSave && (
          <Snackbar
            open={this.state.updatedSnack}
            message={this.props.t("profile_updated")}
            action={
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={this.handleSnackClose}
              >
                <CloseIcon />
              </IconButton>
            }
          />
        )}
      </div>
    );
  }

  checkRequiredFieldsAreFilled = () => {
    if (
      !this.state.passwordError &&
      !this.state.confirmPasswordError &&
      !this.state.emailError &&
      !this.state.emailRegExError &&
      !this.state.passwordsDontMatch &&
      !this.state.passwordRegexError &&
      this.state.userLogin &&
      this.state.firstName &&
      this.state.surname
    ) {
      this.props.saveButtonDisable(false);
    } else {
      this.props.saveButtonDisable(true);
    }
  };

  checkPasswordsMatch = () => {
    this.state.password === this.state.confirmPassword
      ? this.setState({ passwordsDontMatch: false }, () => {
          this.checkRequiredFieldsAreFilled();
        })
      : this.setState({ passwordsDontMatch: true }, () => {
          this.checkRequiredFieldsAreFilled();
        });
  };

  buildRegexForOrganisation = () => {
    let regExString = "^(?=.*[a-z])";
    let passwordStrengthRequirements = JSON.parse(
      this.props.applicationProperties[
        "administration.useradmin.passwordstrengthrequirements"
      ]
    );
    if (passwordStrengthRequirements.useCapitals) {
      regExString += "(?=.*[A-Z])";
    }
    if (passwordStrengthRequirements.useNumbers) {
      regExString += "(?=.*\\d)";
    }
    if (passwordStrengthRequirements.useSpecialCharacters) {
      regExString += "(?=.*[@$!%*?&^.()])";
    }
    if (passwordStrengthRequirements.minimumCharacters != null) {
      regExString +=
        "[A-Za-z\\d@$!%*?&^.()]{" +
        passwordStrengthRequirements.minimumCharacters +
        ",}$";
    }
    this.setState({ regEx: regExString });
  };

  buildPasswordErrorMessageForOrganisation = () => {
    let passwordErrorMessage = "Your password must have a minimum of ";

    let passwordStrengthRequirements = JSON.parse(
      this.props.applicationProperties[
        "administration.useradmin.passwordstrengthrequirements"
      ]
    );

    if (passwordStrengthRequirements.minimumCharacters != null) {
      passwordErrorMessage +=
        passwordStrengthRequirements.minimumCharacters + " characters, ";
    }
    if (passwordStrengthRequirements.useCapitals) {
      passwordErrorMessage += "one capital letter, ";
    }
    if (passwordStrengthRequirements.useNumbers) {
      passwordErrorMessage += "one number ";
    }
    if (passwordStrengthRequirements.useSpecialCharacters) {
      passwordErrorMessage += " and one special character i.e. @$!%*?&^.()";
    }
    this.setState({ passwordRegexErrorMessage: passwordErrorMessage });
  };

  handlePasswordChange = (e) => {
    this.setState({ passwordTouched: true });
    let passwordRegularExpression = new RegExp(this.state.regEx);

    passwordRegularExpression.test(e.target.value)
      ? e.target.value === ""
        ? this.setState(
            {
              passwordError: true,
              password: e.target.value,
              passwordRegexError: false,
            },
            () => {
              this.checkRequiredFieldsAreFilled();
              this.checkPasswordsMatch();
            }
          )
        : this.setState(
            {
              passwordError: false,
              password: e.target.value,
              passwordRegexError: false,
            },
            () => {
              this.props.stateUpdated(this.state);
              this.checkRequiredFieldsAreFilled();
              this.checkPasswordsMatch();
            }
          )
      : this.setState(
          { passwordRegexError: true, password: e.target.value },
          () => {
            this.checkPasswordsMatch();
          }
        );
  };

  handleConfirmPasswordChange = (e) => {
    this.setState({ confirmPasswordTouched: true });
    this.state.password === e.target.value
      ? e.target.value === ""
        ? this.setState(
            {
              confirmPasswordError: true,
              confirmPassword: e.target.value,
              passwordsDontMatch: false,
            },
            () => {
              this.checkRequiredFieldsAreFilled();
            }
          )
        : this.setState(
            {
              confirmPasswordError: false,
              confirmPassword: e.target.value,
              passwordsDontMatch: false,
            },
            () => {
              this.props.stateUpdated(this.state);
              this.checkRequiredFieldsAreFilled();
            }
          )
      : this.setState(
          {
            passwordsDontMatch: true,
            confirmPassword: e.target.value,
          },
          () => {
            this.checkRequiredFieldsAreFilled();
          }
        );
  };

  handleUsernameChange = (e) => {
    this.setState({ userLogin: e.target.value, usernameTouched: true }, () => {
      this.props.stateUpdated(this.state);
      this.checkRequiredFieldsAreFilled();
    });
  };

  handleSalutationChange = (e) => {
    this.setState({ salutation: e.target.value }, () => {
      this.props.stateUpdated(this.state);
    });
  };

  handleUserTypeChange = (e) => {
    this.setState({ userType: e.target.value }, () => {
      this.props.stateUpdated(this.state);
    });
  };

  handleFirstNameChange = (e) => {
    this.setState({ firstName: e.target.value }, () => {
      this.props.stateUpdated(this.state);
      this.checkRequiredFieldsAreFilled();
    });
  };

  handleLastNameChange = (e) => {
    this.setState({ surname: e.target.value }, () => {
      this.props.stateUpdated(this.state);
      this.checkRequiredFieldsAreFilled();
    });
  };

  handleEmailChange = (e) => {
    const emailRegularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.setState({ emailTouched: true });
    emailRegularExpression.test(e.target.value)
      ? e.target.value === ""
        ? this.setState(
            { emailError: true, email: e.target.value, emailRegExError: false },
            () => {
              this.checkRequiredFieldsAreFilled();
            }
          )
        : this.setState(
            {
              emailError: false,
              email: e.target.value,
              emailRegExError: false,
            },
            () => {
              this.props.stateUpdated(this.state);
              this.checkRequiredFieldsAreFilled();
            }
          )
      : this.setState({ emailRegExError: true, email: e.target.value }, () => {
          this.checkRequiredFieldsAreFilled();
        });
  };

  handleSnackClose = () => {
    this.setState({ updatedSnack: false });
  };

  saveChanges = () => {
    let userRVO = {
      id: this.props.currentUser.id,
      salutation: this.state.salutation,
      firstName: this.state.firstName,
      surname: this.state.surname,
      email: this.state.email,
      userLogin: this.props.currentUser.userLogin,
      password: this.state.password,
    };

    taxServiceClient.patch(`/user/${this.props.currentUser.userId}`, userRVO);
    this.setState({ updatedSnack: true });
  };
}
const mapStateToProps = (state) => ({
  applicationProperties: state.setting.applicationProperties,
});

const mapDispatchToProps = {
  setApplicationProperties,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(ProfilePage)));
